export default {
  url: '/authentications/auth/changePassword',
  method: 'POST',
  isPublic: true
}
